<template>
<div>
    <router-view />
</div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;700;800&display=swap');

#app {
    font-family: 'Montserrat' !important
}

.bordered {
    border-left: 2px solid #ccc;
}

.row-h {
    height: 200px
}

.page-link {
    color: #5c5f62 !important
}

.page-item.active .page-link {
    color: #fff !important
}

.btn-culture {
    height: 50px;
}

.ql-container {
    font-family: 'Montserrat' !important;
}

.pac-container {
    z-index: 11000;
    /* needs to be > z-index modal */
}

.quillWrapper {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%) !important;
    border-radius: 8px !important;
    padding: 17px 16px !important;
    background: #fff !important;
}

.vue-tel-input {
    display: flex !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.invalid-feedback {
    display: block !important;

}

.bg-black {
    background: #000000 !important
}

select .caret {
    background-repeat: no-repeat;
    background-position-x: 98% !important;
    background-position-y: 17px !important;
    background-image: none !important;
}

.row {
    margin-right: 0 !important;
}

.blink {
    animation: blinker 1s infinite;
}

@keyframes blinker {
    from {
        opacity: 1.0;
    }

    50% {
        opacity: 0.3;
    }

    to {
        opacity: 1.0;
    }
}

.shadow-container {
    background: rgba(86, 92, 99, 0.05);
    box-shadow: 2px 6px 19px rgb(0 0 0 / 5%);
    border-radius: 0px 0px 16px 16px;
    padding: 30px 30px 60px 30px;

    @media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 30px 10px 60px 10px;
    }
}

.card-container {
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 5px;
}

.file-container {
    padding: 20px 30px 30px 20px;
    background: #fff;
}

.btn-warning {
    background-color: #F7B131 !important;
    color: #fff !important;
}

.btn-secondary {
    color: #fff;
    background-color: rgba(86, 92, 99, 0.54) !important;
    border-color: transparent !important;
}

.btn-success {
    background: #11B121 !important;
    border-color: transparent !important;
}

.btn-ms {
    color: #fff;
    background-color: #068bc5 !important;
    border-color: #068bc5 !important;
}

.custom-control-label {
    margin-left: 0.5rem !important;
}

.col-form-label {
    font-weight: 600 !important;
}

.main-text {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 64px;
    text-align: center;
    letter-spacing: -0.25px;
    text-transform: uppercase;
    color: #565C63;
    margin-top: 112px;

}

.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%) !important;
    border-radius: 8px;
    padding: 20px 16px;
    border: none !important;
    height: 61px !important;
}

.form-container {
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.05);
    border-radius: 0px 0px 16px 16px;
    background: rgba(86, 92, 99, 0.05);
    padding: 30px 15px 15px 15px;
}

.custome-card {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12) !important;
    border-radius: 16px !important;
    border: none !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: auto !important;
    }
}

.form-control {
    border: none !important;
    padding: 0.8rem 0.75rem;
}

.reportrange-text {
    height: calc(2em + 0.75rem + 15px) !important;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%) !important;
}

.input-group {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 4px !important;
    margin: 14px 0
}

.input-group-text {
    padding: 0.9rem 2px 1rem 1rem !important;
    background-color: #fff !important;
    border: none !important;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    color: rgba(0, 0, 0, 0.54) !important
}

p.breadcrums a {
    color: #565C63 !important
}

.sub-main-text {
    margin: 0px 31%;
    color: #565C63;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 14px;
        margin: 0px 14%;
    }
}

.security-code-container .field-wrap {
    height: 0 !important;
    width: inherit !important;
    line-height: 0 !important;
    font-size: 20px !important;
}

.mx-datepicker {
    width: 100% !important
}

.mx-input {
    border: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%) !important;
    border-radius: 8px !important;
    padding: 17px 16px !important;
    height: calc(2em + 0.75rem + 15px) !important;
    font-size: 1rem !important;
    color: #495057 !important;
}

.block-container .field-wrap {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1) !important;
    border-radius: 4px;
    text-align: center !important;
    padding: 30px !important;
    margin: 0 8px !important;
}

.b-rating-icon {
    color: #FB8200 !important;
    font-size: 10px !important;
}

.star-icon .b-rating-star .b-rating-icon {
    font-size: 30px !important;
}

.b-rating-value {
    font-size: 12px !important;
    font-weight: 500 !important;
    font-family: 'Roboto' !important;
}

.font8 {
    font-size: 8px !important;
}

.font10 {
    font-size: 10px !important;
}

.font12 {
    font-size: 12px !important;

}

.font14 {
    font-size: 14px !important;

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        font-size: 12px !important;

    }
}

.font16 {
    font-size: 1rem;
}

.font18 {
    font-size: 18px !important;

}

.font20 {
    font-size: 20px !important;

}

.font32 {
    font-size: 32px !important;

}

.font-weight-600 {
    font-weight: 600 !important
}

.culture-primary {
    color: #F7B131 !important
}

.culture-secondary {
    color: #979797 !important
}

.text-white {
    color: #fff !important
}

.text-black {
    color: #000 !important
}

.mr-3 {
    margin-right: 1rem;
}

.b-form-btn-label-control.form-control>.form-control {
    padding-top: 1rem !important
}

.b-form-btn-label-control.form-control {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.float-right {
    float: right
}

a {
    text-decoration: none !important;
}

.bg-culture-grey {
    background: #f7f7f7;
}

.mobile {
    display: none !important
}

.page-item.active .page-link {
    background-color: #000000 !important;
    border-color: #f7b131 !important;
}

.autocomplete-list {
    background: #fff;
    padding: 15px;
    font-size: 14px;
    position: absolute;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 0 0 8px 8px;
    z-index: 99;
    width: 92%;
}

.autocomplete-list ul li {
    cursor: pointer;
    border: 1px solid #f6f7f7;
    padding: 5px;
    border-radius: 0 0 5px 5px;
    transition: all 1s ease-in-out;
}

.StripeElement {
    height: 40px;
    padding: 10px 12px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1) !important;
    // transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.address-title {
    background: rgba(86, 92, 99, 0.05);
    border-radius: 4px;
    padding: 10px
}

@media screen and (min-device-width: 360px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
    .desktop {
        display: none !important
    }

    .mobile {
        display: block !important
    }

    .StripeElement {
        height: 40px;
        padding: 10px 12px;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1) !important;
        // transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

}

@media screen and (max-device-width: 320px) and (-webkit-min-device-pixel-ratio: 1) {
    .main-text {
        font-size: 13px;
        margin-top: 50px
    }

    .desktop {
        display: none !important
    }

    .mobile {
        display: block !important
    }
}

@media screen and (min-width: 844px) and (max-width: 320px) and (orientation: landscape) {
    html {
        transform: rotate(-90deg);
        transform-origin: left top;
        width: 100vh;
        overflow-x: hidden;
        position: absolute;
        top: 100%;
        left: 0;
    }
}

@media screen and (min-device-width: 712px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {

    .ipad,
    .tab {
        display: block !important
    }

    .non_ipad,
    .non_tab {
        display: none !important
    }

    .font8 {
        font-size: 8px !important
    }

    .f-14 {
        font-size: 14px !important
    }

    .btn-culture,
    .btn-warning {
        font-size: 0.5rem !important
    }
}
</style>

<script>
export default {
    name: 'app',
    metaInfo() {
        return {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: "Culture Square",
            // all titles will be injected into this template
            titleTemplate: "%s | Connecting various cultures through food, language and events",
        };
    },
    created() {
        this.$root.$refs.A = this;
    },
    methods: {
        makeToast(variant = null, msg) {
            this.$bvToast.toast(msg, {
                title: 'Message',
                variant: variant,
                solid: true
            });
        },
        openMenu(id) {
            var slide = document.getElementById(id)
            slide.style.marginLeft = "calc(-40em + 10px)"
            if (slide.style.marginLeft === 'calc(-40em + 10px)') {
                slide.style.marginLeft = '-24px'

            } else {
                slide.style.marginLeft = "calc(-40em + 10px)"

            }
        },
        hideSidemenu(id) {
            var slide = document.getElementById(id)
            slide.style.marginLeft = "calc(-40em + 10px)"

        },
    }
}
</script>
